import React from "react";
import LoginForm from "./LoginForm";

function LoginPageV1() {
  return <LoginForm />;
}

export default LoginPageV1;
